import { Box, Link, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import { yoplPlatformTerms } from '../../../constants';
import InputCheckbox from '../../generic/form/InputCheckbox';

const textProps = {
  as: 'span',
};

const CheckoutGeneralConditions = ({ teamName, teamCgv, feeIncluded, ...dataProps }) => {
  return (
    <InputCheckbox fieldName="generalConditions" {...dataProps}>
      <Box fontSize="xs">
        <Text {...textProps}>
          <Trans>I have read and agree to the Terms and Conditions of</Trans>{' '}
        </Text>

        {teamCgv && (
          <Link href={teamCgv} isExternal>
            {teamName}
          </Link>
        )}
        {!teamCgv && <Text {...textProps}>{teamName}</Text>}

        {/* === for retrocompat when null */}
        {feeIncluded === false && (
          <>
            <Text {...textProps}>
              {' '}
              <Trans>as well as the</Trans>{' '}
            </Text>
            <Link href={yoplPlatformTerms()} isExternal>
              <Trans>Platform Terms of Service</Trans>
            </Link>
          </>
        )}
      </Box>
    </InputCheckbox>
  );
};

export default CheckoutGeneralConditions;
